import React, { useEffect } from 'react'
import Select from 'react-select'
import CreatableSelect from 'react-select/creatable'

// Define the type of option
export interface OptionType {
    label: string
    value: string
}

const customStyles = {
    option: (provided: any, state: any) => ({
        ...provided,
        borderBottom: '1px solid gray',
        color: state.isSelected ? 'white' : 'gray',
        padding: 10,
    }),

    valueContainer: (provided: any) => ({
        ...provided,
        flexWrap: 'wrap',
    }),

    control: () => ({
        // your existing styles
        display: 'flex',
        //flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: '0.375rem',
        background: '#fff',
        borderColor: '#E2E8FO',
        borderStyle: 'solid',
        borderWidth: '1px',
        boxShadow: 'none',
        cursor: 'text',
        outline: '0',
        // position: 'relative',
        transition: 'all 100ms',
        minHeight: '2rem',
        maxHeight: 'max-content',
        padding: '0.25rem',
        maxWidth: '100%',
        overflow: 'scroll',
    }),
    multiValue: (provided: any) => ({
        ...provided,
        flexWrap: 'wrap',
        overflow: 'scroll',
        // additional styles if needed
    }),
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    // container: () => ({
    //     height: '2.5rem',
    // }),
}

type Props = {
    options?: OptionType[]
    onChange: (arg: OptionType[]) => void
    placeholder?: string
    value?: OptionType[]
    tabIndex?: number
    createable?: boolean
}

const SelectWithTags = ({ options = [], onChange, placeholder, value = [], tabIndex, createable = true }: Props) => {
    const [selectedOptions, setSelectedOptions] = React.useState<OptionType[]>(value)

    const handleChange = (options: OptionType[]) => {
        setSelectedOptions(options)
        onChange(options)
    }

    useEffect(() => {
        setSelectedOptions(value)
    }, [value])

    if (!createable) {
        return (
            <Select
                isMulti
                isClearable
                name='tags'
                options={options}
                className='basic-multi-select'
                classNamePrefix='select'
                styles={customStyles}
                value={selectedOptions}
                onChange={handleChange as any}
                placeholder={placeholder}
                tabIndex={tabIndex}
            />
        )
    }

    return (
        <CreatableSelect
            isMulti
            isClearable
            name='tags'
            options={options}
            className='basic-multi-select'
            classNamePrefix='select'
            styles={customStyles}
            value={selectedOptions}
            onChange={handleChange as any}
            placeholder={placeholder}
            tabIndex={tabIndex}
            formatCreateLabel={(inputValue: string) => (inputValue ? `Add "${inputValue}"` : '')}
        />
    )
}

export default SelectWithTags
